import { render, staticRenderFns } from "./datos-perfil-inmo.vue?vue&type=template&id=548ef592&scoped=true&lang=html&"
import script from "./datos-perfil-inmo.vue?vue&type=script&lang=js&"
export * from "./datos-perfil-inmo.vue?vue&type=script&lang=js&"
import style0 from "./datos-perfil-inmo.vue?vue&type=style&index=0&id=548ef592&prod&lang=scss&scoped=true&"
import style1 from "./datos-perfil-inmo.vue?vue&type=style&index=1&id=548ef592&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ef592",
  null
  
)

export default component.exports